import { Field, useField } from 'formik';
import { SEARCH_THRESHOLD, YES_NO, choiceBtnClass } from './helper';
import { blueCheckboxCardClass, blueCheckboxClass } from 'components/Profile/helper';
import SearchPicker from './SearchPicker';

const GroupCard = ({ name, title, icon: Icon, question, prompt, searchPlaceholder, items = [] }) => {
  const [{ value: answer }, , answerHelpers] = useField(`answers.${name}`);
  const [{ value: picked }, , pickedHelpers] = useField(name);

  const pickedItems = items.filter(({ id }) => picked?.[id]);
  const selectedNames = pickedItems.map(({ attributes }) => attributes.name);

  const searchable = items.length > SEARCH_THRESHOLD;
  const visibleItems = searchable ? pickedItems : items;

  const handleAnswer = (value) => {
    answerHelpers.setValue(value);

    if (!value) pickedHelpers.setValue(Object.fromEntries(items.map(({ id }) => [id, false])));
  };

  const subtitle = answer === false
    ? 'None — nothing to add'
    : selectedNames.length
      ? selectedNames.join(', ')
      : answer
        ? prompt
        : question;

  return (
    <div className={`rounded-xl border transition-colors ${answer ? 'border-blue-200 bg-blue-50/40' : 'border-gray-200 bg-white'}`}>
      <div className="flex flex-wrap items-center gap-3 p-3.5">
        <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border ${answer ? 'border-blue-200 bg-blue-50 text-blue-500' : 'border-gray-200 bg-gray-50 text-gray-400'}`}>
          <Icon size={18} />
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-bold text-base-content">{title}</p>
          <p className="truncate text-[13px] text-gray-400">{subtitle}</p>
        </div>

        <div className="flex w-full shrink-0 gap-2 sm:w-auto">
          {YES_NO.map(({ label, value }) => (
            <button
              key={label}
              type="button"
              aria-pressed={answer === value}
              onClick={() => handleAnswer(value)}
              className={choiceBtnClass(answer === value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {answer && (
        <div className="animate-slide-up mx-3.5 border-t border-base-200 py-3.5">
          {searchable && (
            <SearchPicker
              name={name}
              items={items}
              picked={picked}
              onChange={pickedHelpers.setValue}
              placeholder={searchPlaceholder}
            />
          )}

          {visibleItems.length ? (
            <div className="grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {visibleItems.map(({ id, attributes }) => (
                <label
                  key={id}
                  title={attributes.name}
                  className={`flex min-w-0 cursor-pointer items-center gap-3 rounded-xl border border-base-300 bg-white px-3.5 py-2.5 transition-colors ${blueCheckboxCardClass}`}
                >
                  <Field
                    type="checkbox"
                    name={`${name}.${id}`}
                    className={`checkbox checkbox-sm shrink-0 [--chkfg:white] border-gray-300 ${blueCheckboxClass}`}
                  />
                  <span className="min-w-0 truncate text-[13px] font-medium">{attributes.name}</span>
                </label>
              ))}
            </div>
          ) : searchable ? (
            <p className="text-xs text-gray-400">Nothing picked yet — start typing above to find it.</p>
          ) : (
            <p className="text-xs text-gray-400">Nothing to pick from here — describe it under Anything Else below.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default GroupCard;
